module.exports = __webpack_public_path__ + "static/img/Apple1.c7b6ce48.jpg";